
import { PostConfig, post } from "@/assets/utils/common";
import { api } from "@/assets/utils/config";
import { Toast } from "vant";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      schemeUrl: "",
    };
  },

  mounted() {
    this.getUrlScheme();
  },

  methods: {
    getUrlScheme() {
      let config: PostConfig = {
        url: api.getUrlScheme,
        param: { path: "pages/index/index" },
      };
      return post(config).then((res: any) => {
        if (res.status == 0) {
          this.schemeUrl = res.data;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toMiniProgram() {
      if (!this.schemeUrl) {
        Toast.loading("请稍等...");
        this.getUrlScheme().then(() => {
          location.href = this.schemeUrl;
        });
        return;
      }
      location.href = this.schemeUrl;
    },
  },
});
